<template>
  <InformationsBar v-show="information.show === true" v-for="information in informationStore.activeInformations" :key="information.uuid" :information="information" />
  <div class="flex flex-col items-center">
    <div class="flex flex-col lg:flex-row justify-between w-full px-8 pt-4 gap-2 lg:gap-0">
      <div class="flex flex-col lg:flex-row lg:items-center gap-2 lg:gap-4">
        <TitreDeux :content='t("filter")' fontSemiBold />

        <DropDownField :placeholder='t("user")' :values="userForFilter"
          @change="fetchCommandes(true)" v-model="userSelectedFilter"/>

        <DropDownField :placeholder="t('status')" :values="etatForFilter"
          @change="fetchCommandes(true)" v-model="etatSelectedFilter"/>
      </div>

      <BlueButton v-show="!isMultiCommandeMode" :text='t("selectMultipleOrder")' @click="startMultiCommandeMode" />
      <div v-show="isMultiCommandeMode" class="flex gap-2">
        <BlueButton :text='selectedMultiCommande.length + " " + t("forInvoice")' @click="downloadNewMultiOrderInvoice" />
        <BlueButton :text='selectedMultiCommande.length + " " + t("changeToStatus") + " " + t("endedAndPaid")' @click="saveMultipleEndAnPaid()" />
      </div>
    </div>

    <TitreUn v-show="commandeStores.commandes.length === 0 && !commandeStores.commandesLoading" class="mt-16" :content='t("noOrderCorresponding")' />

    <AnimatedList class="justify-center mx-8 mt-8 w-full">
      <IdCardCommande :toogleOrderToMultiOrderSelect="toogleOrderToMultiOrderSelect" :isMultiCommandeMode="isMultiCommandeMode"
                      :isSelectecdForMultiSelect="selectedMultiCommande.includes(commande.uuid)" v-for="commande of commandeStores.commandes"
                      :commande="commande" :key="commande.uuid"/>
    </AnimatedList>

    <BlueButton v-show="commandeStores.hasMore && commandeStores.commandes.length > 0" class="w-1/2 my-8"
          @click="fetchCommandes(false)" :text='t("showMore")' />
  </div>

</template>

<script setup>

import IdCardCommande from "@/components/organismes/IdCardCommande.vue";
import {CommandeStores} from "@/stores/CommandeStores";
import {router} from "@/routeur";
import {UtilisateurStores} from "@/stores/UtilisateurStores";
import {NotificationStores} from "@/stores/NotificationStores";
import {enumeration} from '../../Enumeration';
import {t} from "@/utils/Traduction";
import {InformationStore} from "@/stores/InformationStore";
import InformationsBar from "@/components/molecules/InformationsBar.vue";
import {computed, ref} from "vue";
import {EtatStore} from "@/stores/EtatStore";
import DropDownField from "@/components/molecules/DropDownField.vue";
import TitreDeux from "@/components/atoms/TitreDeux.vue";
import BlueButton from "@/components/molecules/BlueButton.vue";
import TitreUn from "@/components/atoms/TitreUn.vue";
import AnimatedList from "@/components/molecules/AnimatedList.vue";
import xhr from "@/utils/xhr";
import {jsonValidator} from "@/utils/JsonValidator";

const utilisateurStore = UtilisateurStores();
const notificationStore = NotificationStores();
const informationStore = InformationStore();
const etatStore = EtatStore();

if(utilisateurStore.role !== enumeration.role.ADMIN) {

  utilisateurStore.logout(false);
  notificationStore.addNotification(t("youNeedToBeAdminToAccessThisPage"), 'error');
  router.push({ path: "/"});
}

const commandeStores = CommandeStores();

informationStore.loadActiveInformations();
utilisateurStore.loadClients();
etatStore.loadEtatsCommandes();

const userSelectedFilter = ref("null");
const etatSelectedFilter = ref("null");
const isMultiCommandeMode = ref(false);
const selectedMultiCommande = ref([]);

const userForFilter = computed(() => {
  const client = utilisateurStore.clients.map(u => ({id: u.uuid, display: u.email}));
  return [{id: "null", display: t("allClient")}, ...client];
});

const etatForFilter = computed(() => {
  const etat = etatStore.etats.map(e => ({id: e.uuid, display: e.libelle}));
  return [{id: "null", display: t("allStatus")}, ...etat];
})

const startMultiCommandeMode = () => {
  isMultiCommandeMode.value = true;
  selectedMultiCommande.value = [];
}

const toogleOrderToMultiOrderSelect = (uuid) => {
  if(selectedMultiCommande.value.includes(uuid)) {
    selectedMultiCommande.value = selectedMultiCommande.value.filter((value) => value !== uuid);
  } else {
    selectedMultiCommande.value.push(uuid);
  }
}

const downloadNewMultiOrderInvoice = async () => {

  if(selectedMultiCommande.value.length === 0) {
    notificationStore.addNotification(t("noOrderSelected"), 'error');
    return;
  }

  await commandeStores.downloadMultiOrderInvoice(selectedMultiCommande.value);
  isMultiCommandeMode.value = false;
  selectedMultiCommande.value = [];
}

const saveMultipleEndAnPaid = async () => {

  const fullSelectedCommande = commandeStores.commandes.filter(c => selectedMultiCommande.value.includes(c.uuid))
  const fullCommandesEnded = fullSelectedCommande.filter(c => c.etat.libelle === enumeration.etatCommande.TERMINEE);

  if(fullCommandesEnded.length === 0) {
    notificationStore.addNotification(t("noOrderEndedNotPaidSelected"), 'error');
    return;
  }

  xhr.addRequestToQueue("PUT", `/commandes/etat/endAndPaid`,
      {uuidCommandes: fullCommandesEnded.map(c => c.uuid)}, true, true, false, (response) => {
        if(response.code !== 200) {
          if(response.code === 0 || !jsonValidator.validate(response.response)) {
            notificationStore.addNotification(
                t("errorDuringServerConnexion"),
                "error");
          } else {
            notificationStore.addNotification(
                JSON.parse(response.response).message,
                "error");
          }
        } else {
          notificationStore.addNotification(
              t("ordersStatusUpdated"),
              "success");

          isMultiCommandeMode.value = false;
          selectedMultiCommande.value = [];

          const etat = etatStore.etats.find(e => e.libelle === enumeration.etatCommande.TERMINEE_ET_PAYEE)
          const uuidChanged = JSON.parse(response.response);

          commandeStores.commandes.forEach(commande => {
            if (uuidChanged.includes(commande.uuid)) {
              commande.etat = etat;
            }
          });
        }
      });

}

const fetchCommandes = (reset) => {

  if(reset === true) {
    commandeStores.commandesOffset = 0;
    commandeStores.commandes = [];
    commandeStores.hasMore = true;
  }

  commandeStores.getCommandeFromOffsetAdmin(userSelectedFilter.value, etatSelectedFilter.value);
  commandeStores.commandesOffset += 20;
}

if(commandeStores.commandes.length === 0) {
  fetchCommandes(true)
}


</script>

<style scoped>

</style>